<template>
  <div class="table">
    <div class="t-head">
      <div class="row">
        <div class="col-12 col-xl-5 tw-flex tw-items-center tw-space-x-2">
          <div class="car-stock-header in-stock"></div>
          <label for="in_stock" class="tw-leading-loose">Elérhető:</label>
          <label class="switch">
            <input
                id="in_stock"
                v-model="onlyInStock"
                type="checkbox"
            >
            <span class="roundedslider round"></span>
          </label>
        </div>
        <div class="col-12 col-xl-1 d-none d-xl-block">
          Teljesítmény
        </div>
        <div class="col-12 col-xl-1 d-none d-xl-block">
          Üzemanyag
        </div>
        <div class="col-12 col-xl-1 d-none d-xl-block">
          Váltó
        </div>
        <div class="col-12 col-xl-1 d-none d-xl-block">
          Ülések száma
        </div>
        <div class="col-12 col-xl-1 d-none d-xl-block">
          Listaár
        </div>
        <div class="col-12 col-xl-2 price d-none d-xl-block">
          Bérleti díj
        </div>
      </div>
    </div>
    <div class="t-body">
      <div
        v-for="item in types"
        :key="item.TYPNatCode"
        class="row type-row "
        v-bind:class="{'highlighted':
        item.config.on_sale||
        item.config.green_cars||
        item.config.flag1||
        item.config.flag2||
        item.config.flag3||
        item.config.flag4||
        item.config.flag5 ||

        modelConfig.on_sale ||
        modelConfig.green_cars||
        modelConfig.flag1 ||
        modelConfig.flag2 ||
        modelConfig.flag3 ||
        modelConfig.flag4 ||
        modelConfig.flag5 ||

        makeConfig.on_sale ||
        makeConfig.green_cars||
        makeConfig.flag1 ||
        makeConfig.flag2 ||
        makeConfig.flag3 ||
        makeConfig.flag4 ||
        makeConfig.flag5,
        'highlighted':isEmphasized(item)
      }"
        @click="onRowClicked(item.publicUrl)"
      >
        <div class="col-12 col-xl-5 type tw-flex tw-items-center tw-gap-2"
        >
          <h3>
            {{ item.model.name|brandToUpper(makeName) }} {{ dedupedTypeName(item) }}
          </h3>
          <span class="bic-card__featured-badge" v-if="item.config && item.config.bic">Kiemelt ajánlat</span>
          <span class="tw-hidden xl:tw-inline-block badge badge-danger tw-py-1 text-uppercase" v-if="item.stock_number > 0">KÉSZLETEN</span>
          <month-badge v-else :date="item.take_over_month"></month-badge>

          <fuel-type-badge :fuel-type="item.fuelType" ></fuel-type-badge>

        </div>

        <div
            class="col-12 xl:tw-hidden before:!tw-hidden tw-mb-2"
            v-if="item.stock_number > 0"
        >
          <span class="badge badge-danger text-uppercase">Készleten</span>

        </div>
        <div
            class="col-12 xl:tw-hidden before:!tw-hidden tw-mb-2"
            v-else
        >
          <month-badge :date="item.take_over_month"></month-badge>
        </div>


        <div
            class="col-12 col-xl-1 text-nowrap"
            data-title="Teljesítmény:"
        >
          {{ item.ph }}
        </div>
        <div
          class="col-12 col-xl-1 text-nowrap"
          data-title="Üzemanyag:"
        >
          {{ item.fuelType }}
        </div>
        <div
          class="col-12 col-xl-1 text-nowrap"
          data-title="Váltó:"
        >
          {{ item.transType }}
        </div>
        <div
          class="col-12 col-xl-1 text-nowrap"
          data-title="Ülések száma:"
        >
          {{ item.TYPSeat  }} fő
        </div>
        <div
          class="col-12 col-xl-1 text-nowrap"
          data-title="Listaár:"
        >
          <span v-if="item.price">{{ item.price.grossPrice }} Ft</span>
        </div>
        <div
          class="col-12 col-xl-2 price text-nowrap"
          data-title="Bérleti díj"
        >
          <a
            :href="getUrl(item.publicUrl)"
            class="btn btn-secondary btn-sm"
          >
            <span
              v-if="item.configurator_price"
            >
              {{ getItemPrice(item) | currency }} Ft + ÁFA
            </span>
            <span v-else>
              Hívjon bennünket!
            </span>
          </a>
        </div>
        <img
          src="/images/car-placeholder.jpg"
          class="img-fluid img-mobile" 
          :alt="generateCarPlaceholderAlt(item)"
        >
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const typeModule = namespace('type');

  @Component
  export default class TypeTable extends Vue {
    @typeModule.Getter('getFilteredItems') filteredItems;

    @Prop(Boolean) withModel;
    @Prop(String) makeName;
    @Prop(Object) makeConfig;
    @Prop(Object) modelConfig;

    onlyInStock = false;
    price_filter = null;
    priceKey = null;

    created() {
      const searchParams = new URLSearchParams(location.search);

      this.price_filter = JSON.parse(localStorage.getItem('filter'));
      if (this.price_filter && this.price_filter.contractLength && this.price_filter.annualMileage){
        localStorage.removeItem('filter');
        this.priceKey = `price_${this.price_filter.contractLength}_${this.price_filter.annualMileage}`;
      }else{
        this.priceKey = `min_price_net`;
      }

      this.onlyInStock = !!searchParams.get('stock');
    }

    isEmphasized(row) {
      if (row.configurator_price && this.priceKey && this.price_filter) {
        if (row.configurator_price[this.priceKey] > this.price_filter.min_price
            && row.configurator_price[this.priceKey] < this.price_filter.max_price) {
          return true;
        }
      }

      return false;
    }

    dedupedTypeName(item) {
      const typeName = item.TYPName || '';
      const modelName = item.model && item.model.MODNameGrp1;

      if (!modelName) return typeName;

      const trimmedModel = modelName.trim();
      const trimmedType = typeName.trim();
      if (!trimmedModel || !trimmedType.toLowerCase().startsWith(trimmedModel.toLowerCase())) return typeName;

      const remainder = trimmedType.slice(trimmedModel.length);
      if (remainder === '' || remainder.startsWith(' ')) return remainder.trim();

      return typeName;
    }

    getItemPrice(item) {
      const price = item.configurator_price;

      // The saved filter can point at a contract length this car is not priced for, so fall back to
      // its cheapest available fee rather than rendering an empty cell.
      if (this.priceKey && price[this.priceKey]) {
        return price[this.priceKey];
      }

      return price.min_price_net;
    }

    get types() {
      return this.filteredItems
        .filter(item => {
          if (this.onlyInStock) {
            return item.stock_number >0 || item.take_over_month
          }

          return true
        })
    }

    onRowClicked(url) {
      if (this.onlyInStock) {
        localStorage.setItem('filter', JSON.stringify(this.price_filter));
        location.href = url + "/raktari";
      } else {
        localStorage.setItem('filter', JSON.stringify(this.price_filter));
        location.href = url;
      }
    }
    getUrl(url){
      if (this.onlyInStock) {
        localStorage.setItem('filter', JSON.stringify(this.price_filter));
        return  url + "/raktari";
      } else {
        localStorage.setItem('filter', JSON.stringify(this.price_filter));
        return  url;
      }
    }

    generateCarPlaceholderAlt(item) {
      const makeName = item.model?.make?.name || 'Autó';
      const modelName = item.model?.MODNameGrp1 || item.TYPName || '';
      const bodyType = item.body_type_name || '';
      
      return `${makeName} ${modelName} ${bodyType} autólízing`;
    }
  }
</script>

<style scoped>
  .type-row {
    cursor: pointer;
  }
</style>
